module.exports = __webpack_public_path__ + "img/Lambent_Plume.f1a694c6.png";